import { captureRemixErrorBoundaryError } from "@sentry/remix";
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteError,
  useLocation,
} from "@remix-run/react";

export const ErrorBoundary = () => {
  const error = useRouteError();
  captureRemixErrorBoundaryError(error);
  return <div>Something went wrong</div>;
};

export default function App() {
  const { pathname } = useLocation();
  const isProxy = pathname.includes("proxy-for-editor");
  return (
    <html>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="preconnect" href="https://cdn.shopify.com/" />
        <link
          rel="stylesheet"
          href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css"
        />
        {/* <link
          crossOrigin="anonymous"
          rel="stylesheet"
          href="https://ph-np-whitelabel-products-media-storage.s3.eu-central-1.amazonaws.com/editor/1.1.2/static/css/main.6d666b75.css"
        />
        <link
          crossOrigin="anonymous"
          rel="modulepreload"
          href="https://ph-np-whitelabel-products-media-storage.s3.eu-central-1.amazonaws.com/editor/1.1.2/static/js/main.1079ef25.js"
        /> */}
        <Meta />
        <Links />
      </head>
      <body>
        <Outlet />
        <ScrollRestoration />
        {!isProxy && <Scripts />}
      </body>
    </html>
  );
}
